import moment from 'moment';
import templateStr from 'text!./policy-billing-summary.html';

export default (function () {
    return {
        restrict: 'A',
        template: templateStr,
        scope: {
            title: '@',
            policyBillingSummary: '=',
            accountNumber: '@'
        },
        controller: ['$stateParams', '$scope', '$filter', 'PolicyService', 'InsuranceSuiteMetadata', 'MSFEnvironmentsNameLookup', 'PayNowLink', '$window', function ($stateParams, $scope, $filter, PolicyService, InsuranceSuiteMetadata, MSFEnvironmentsNameLookup, PayNowLink, $window) {
            $scope.loading = true;
            $scope.recentPayment = '';

            $scope.msfHost = PolicyService.getMsfPortalHost();
            $scope.msfHost.then(function (MSFHost) {
                $scope.payNowLink = MSFHost + PayNowLink;
            }, function (err) {
                console.error('Error while retrieving MSF host: ', err);
            });

            init();

            function init() {
                if (angular.isDefined($scope.policyBillingSummary) && angular.isDefined($scope.policyBillingSummary.policyPeriodBillingSummaries)) {
                    createPolicyPeriodBillingSummaries($scope.policyBillingSummary);
                    $scope.paymentScheduleReturnMessage = $filter('translate')('gateway.directives.PolicyBillingSummaryDirective.policy-billing-summary.No payments scheduled for this policy');
                }
                $scope.loading = false;
            }

            // DEF-3054. This method is not used anywhere and seems replaced by the DTO property MSFRecentPayments_Ext
            /* PolicyService.getRecentPaymentForPolicy($stateParams.policyNumber).then(function(res){
                if(res!=undefined && res!=null){
                var data={"currency":"usd","amount":0.00};
                data.amount=res.split('usd')[0].trim()
                $scope.recentPayment =data;
            }
            });*/

            function createPolicyPeriodBillingSummaries(policyBillingSummary) {
                $scope.policyPeriodBillingSummaries = [];
                policyBillingSummary.policyPeriodBillingSummaries.forEach(function (summary, index) {
                    var policyPeriodBillingSummary = populateBillingSummaryData(summary, index);

                    $scope.policyPeriodBillingSummaries.push(policyPeriodBillingSummary);
                });
                $scope.currentPolicyPeriodBillingSummary = $scope.policyPeriodBillingSummaries[0];
            }

            function populateBillingSummaryData(summary, index) {
                var policyPeriodBillingSummary = angular.copy(summary);
                policyPeriodBillingSummary.periodName = '#' + (index + 1) + ': ' + summary.periodName;

                policyPeriodBillingSummary.status = summary.isDelinquent === true ? $filter('translate')('gateway.directives.PolicyBillingSummaryDirective.policy-billing-summary.Delinquent') : $filter('translate')('gateway.directives.PolicyBillingSummaryDirective.policy-billing-summary.In Good Standing');

                if (angular.isDefined(summary.billingMethod)) {
                    policyPeriodBillingSummary.billingMethod = InsuranceSuiteMetadata.get('pc').types.getTypelist('BillingMethod').getCode(summary.billingMethod).name;
                } else {
                    policyPeriodBillingSummary.billingMethod = '-';
                }

                if (!angular.isDefined(summary.alternativeBillingAccount)) {
                    policyPeriodBillingSummary.alternativeBillingAccount = '-';
                }

                if (!angular.isDefined(summary.invoiceStream)) {
                    policyPeriodBillingSummary.invoiceStream = '-';
                }

                if (angular.isDefined(summary.invoices)) {
                    summary.invoices.forEach(function (invoice) {
                        updateInvoiceData(invoice);
                    });
                }

                return policyPeriodBillingSummary;
            }

            function updateInvoiceData(invoice) {
                if (moment().isAfter(invoice.dueDate, ['year', 'month', 'day']) && invoice.unpaid.amount > 0) {
                    invoice.paidStatus = $filter('translate')('gateway.directives.PolicyBillingSummaryDirective.policy-billing-summary.Past Due');
                    invoice.showPastDueAlert = true;
                } else {
                    invoice.showPastDueAlert = false;
                }
            }

            $scope.$watch('policyBillingSummary', function () {
                if (angular.isDefined($scope.policyBillingSummary) && angular.isDefined($scope.policyBillingSummary.policyPeriodBillingSummaries)) {
                    createPolicyPeriodBillingSummaries($scope.policyBillingSummary);
                    $scope.paymentScheduleReturnMessage = $filter('translate')('gateway.directives.PolicyBillingSummaryDirective.policy-billing-summary.No payments scheduled for this policy');
                }
            });
        }]
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/directives/PolicyBillingSummaryDirective/PolicyBillingSummary.js
// module id = 1754
// module chunks = 0